module.exports = __webpack_public_path__ + "img/d200901-1.d427a11a.jpg";